import type { CampaignFormData } from '../types';

interface Step1Props {
  data: CampaignFormData;
  onChange: (field: keyof CampaignFormData, value: string) => void;
}

const categories = [
  { id: 'تعليم', label: 'تعليم وتطوير', icon: 'ri-book-open-line' },
  { id: 'مشاريع', label: 'مشاريع ريادية', icon: 'ri-briefcase-line' },
  { id: 'إبداع', label: 'إبداع وفنون', icon: 'ri-palette-line' },
  { id: 'تقنية', label: 'تقنية وبرمجة', icon: 'ri-code-line' },
  { id: 'طعام', label: 'طعام ومطاعم', icon: 'ri-restaurant-line' },
  { id: 'زراعة', label: 'بيئة وزراعة', icon: 'ri-plant-line' },
  { id: 'رياضة', label: 'رياضة ولياقة', icon: 'ri-run-line' },
  { id: 'صحة', label: 'صحة وعافية', icon: 'ri-heart-pulse-line' },
];

const Step1BasicInfo = ({ data, onChange }: Step1Props) => (
  <div className="space-y-6" dir="rtl">
    <div>
      <h2 className="text-xl font-black text-stone-800 mb-1">المعلومات الأساسية</h2>
      <p className="text-stone-500 text-sm">ابدأ بتعريف الناس بحملتك</p>
    </div>

    {/* Title */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        عنوان الحملة <span className="text-red-400">*</span>
      </label>
      <input
        type="text"
        value={data.title}
        onChange={(e) => onChange('title', e.target.value)}
        placeholder="مثال: دعم مشروع تطبيق تعليمي للأطفال"
        maxLength={80}
        className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 focus:outline-none focus:border-emerald-400 text-right placeholder-stone-400"
      />
      <div className="flex justify-between mt-1">
        <span className="text-xs text-stone-400">اجعله واضحاً وجذاباً</span>
        <span className="text-xs text-stone-400">{data.title.length}/80</span>
      </div>
    </div>

    {/* Category */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-3">
        فئة الحملة <span className="text-red-400">*</span>
      </label>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => onChange('category', cat.id)}
            className={`flex flex-col items-center gap-2 p-3 rounded-xl border-2 transition-all cursor-pointer ${
              data.category === cat.id
                ? 'border-emerald-500 bg-emerald-50 text-emerald-700'
                : 'border-stone-200 hover:border-stone-300 text-stone-600'
            }`}
          >
            <i className={`${cat.icon} text-lg`}></i>
            <span className="text-xs font-medium text-center leading-tight">{cat.label}</span>
          </button>
        ))}
      </div>
    </div>

    {/* Location */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        المدينة <span className="text-red-400">*</span>
      </label>
      <div className="relative">
        <select
          value={data.location}
          onChange={(e) => onChange('location', e.target.value)}
          className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 focus:outline-none focus:border-emerald-400 appearance-none bg-white text-right cursor-pointer"
        >
          <option value="">اختر مدينتك</option>
          {['الرياض', 'جدة', 'مكة المكرمة', 'المدينة المنورة', 'الدمام', 'الخبر', 'الأحساء', 'تبوك', 'أبها', 'القصيم'].map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </select>
        <i className="ri-arrow-down-s-line absolute left-3 top-1/2 -translate-y-1/2 text-stone-400 pointer-events-none"></i>
      </div>
    </div>

    {/* Short Description */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        وصف مختصر <span className="text-red-400">*</span>
      </label>
      <textarea
        value={data.shortDesc}
        onChange={(e) => onChange('shortDesc', e.target.value)}
        placeholder="اكتب جملة أو جملتين تلخصان حملتك بشكل جذاب..."
        rows={3}
        maxLength={200}
        className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-700 focus:outline-none focus:border-emerald-400 resize-none text-right placeholder-stone-400"
      />
      <div className="flex justify-end mt-1">
        <span className="text-xs text-stone-400">{data.shortDesc.length}/200</span>
      </div>
    </div>
  </div>
);

export default Step1BasicInfo;
